var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 2.35002L6.86002 7.64002C6.66002 7.84002 6.66002 8.15002 6.86002 8.35002L8.15002 9.64002C8.35002 9.84002 8.66002 9.84002 8.86002 9.64002L12.15 6.35002C12.35 6.15002 12.66 6.15002 12.86 6.35002L16.15 9.64002C16.35 9.84002 16.66 9.84002 16.86 9.64002L18.15 8.35002C18.35 8.15002 18.35 7.84002 18.15 7.64002L12.86 2.35002C12.66 2.16002 12.34 2.16002 12.15 2.35002Z",
    fill: "#a799ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 21.65L6.86002 16.36C6.66002 16.16 6.66002 15.85 6.86002 15.65L8.15002 14.36C8.35002 14.16 8.66002 14.16 8.86002 14.36L12.15 17.65C12.35 17.85 12.66 17.85 12.86 17.65L16.15 14.36C16.35 14.16 16.66 14.16 16.86 14.36L18.15 15.65C18.35 15.85 18.35 16.16 18.15 16.36L12.86 21.65C12.66 21.84 12.34 21.84 12.15 21.65Z",
    fill: "#a799ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 10.1L22.14 11.64C22.34 11.84 22.34 12.15 22.14 12.35L20.6 13.89C20.4 14.09 20.09 14.09 19.89 13.89L18.35 12.35C18.15 12.15 18.15 11.84 18.35 11.64L19.89 10.1C20.09 9.91002 20.41 9.91002 20.6 10.1Z",
    fill: "#a799ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10001 10.1L6.64001 11.64C6.84001 11.84 6.84001 12.15 6.64001 12.35L5.10001 13.89C4.90001 14.09 4.59001 14.09 4.39001 13.89L2.85001 12.35C2.65001 12.15 2.65001 11.84 2.85001 11.64L4.39001 10.1C4.59001 9.91002 4.91001 9.91002 5.10001 10.1Z",
    fill: "#a799ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 9.87998L14.62 11.65C14.82 11.85 14.82 12.16 14.62 12.36L12.85 14.13C12.65 14.33 12.34 14.33 12.14 14.13L10.37 12.36C10.17 12.16 10.17 11.85 10.37 11.65L12.14 9.87998C12.34 9.67998 12.66 9.67998 12.85 9.87998Z",
    fill: "#a799ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.309bb4141adc1c743b581fa748a25ece.svg";
export { ForwardRef as ReactComponent };